import {postUnreadAnnouncement} from '../../providers/support/support';

const pushKey = '@pezPush';

export function savaPushMessage(value, updater) {
  updater({savedPushMessage: value});
  localStorage.setItem(pushKey, JSON.stringify(value));
}

export function getPushMessage(updater) {
  const value = localStorage.getItem(pushKey);
  const result = value ? JSON.parse(value) : null;
  updater({savedPushMessage: result});
}

export function deletePushMessageById(id, updater) {
  const value = localStorage.getItem(pushKey);
  let MessageArray = value ? JSON.parse(value) : [];
  let index = MessageArray.findIndex((item) => item.id === id);
  if (index !== -1) {
    MessageArray.splice(index, 1);
    updater({savedPushMessage: MessageArray});
    localStorage.setItem(pushKey, JSON.stringify(MessageArray));
  }
}

export function markAsRead(updater) {
  const value = localStorage.getItem(pushKey);
  let MessageArray = value ? JSON.parse(value) : [];
  let isNeedUpdate = false;
  MessageArray.forEach(function (item) {
    if (!item.status) {
      item.status = true;
      isNeedUpdate = true;
    }
  });
  if (isNeedUpdate) {
    updater({savedPushMessage: MessageArray});
    localStorage.setItem(pushKey, JSON.stringify(MessageArray));
    postUnreadAnnouncement(MessageArray.map((item) => item.id));
  }
}

export function getUnreadCount(array) {
  if (!array) {
    return 0;
  }
  let count = 0;
  array.forEach(function (item) {
    if (!item.status) {
      count++;
    }
  });
  return count;
}
